import React from "react";
import FormErrorMessage from "../FormErrorMessage";
import { find } from "lodash";
import propTypes from "prop-types";

/**
Usage:
const validations = {
  isEmpty: false,
  isInvalid: true
}

<ErrorSwitch validations={validations}>
{{
  isEmpty: t("IS_EMPTY_KEY"),
  isInvalid: t("IS_INVALID_KEY")
}}
</ErrorSwitch>
*/

function ErrorSwitch({ validations, children, name, className = null }) {
  const message = find(children, (message, key) => validations[key] === true);
  if (!message) {
    return null;
  }
  return (
    <FormErrorMessage data-test={`err-switch-${name}`} className={className}>
      {message}
    </FormErrorMessage>
  );
}

ErrorSwitch.propTypes = {
  validations: propTypes.object,
  children: propTypes.object
};

export default ErrorSwitch;
